export const APP_STORE_URL = "https://apps.apple.com/us/app/investx/id6760356439";
export const APP_STORE_ID = "6760356439";
export const APP_STORE_QR_SRC = `${process.env.PUBLIC_URL}/assets/investx-appstore-qr.svg`;

/** Phone-sized viewport or phone-like UA → go straight to App Store. */
export function isMobileDownloadClient() {
  if (typeof window === "undefined") return false;
  const narrow = window.matchMedia("(max-width: 767px)").matches;
  const ua = navigator.userAgent || "";
  const phoneUa =
    /iPhone|iPod|Android.*Mobile|webOS|BlackBerry|IEMobile|Opera Mini/i.test(ua);
  return narrow || phoneUa;
}
